<template>
  <div id="facility">
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="fnAction"
    ></Topbar>
    <v-container class="main left">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm6 md3 class="logo">
          <img :src="facility.image ? facility.image : '/img/stadium.svg'" />
        </v-flex>
        <v-flex xs12 sm6 md9 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name">{{ $t("basic_info") }}</v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.name") }}:</div>
                <div class="value">{{ facility.name | checkParam }}</div>

                <div class="label">{{ $t("params.name_competition") }}:</div>
                <div class="value">
                  {{ facility.name_competition | checkParam }}
                </div>

                <div class="label">{{ $t("params.state") }}:</div>
                <div class="value">{{ facility.state | checkParam }}</div>

                <div class="label">{{ $t("params.cp") }}:</div>
                <div class="value">{{ facility.cp | checkParam }}</div>

                <div class="label">{{ $t("params.municipal") }}:</div>
                <div class="value">
                  {{ si_no_nsncOptions[facility.municipal] | checkParam }}
                </div>

                <div class="label">
                  <Phone :phone="$t('params.phone') + ':'"></Phone>
                </div>
                <div class="value">{{ facility.phone | checkParam }}</div>

                <div class="label">{{ $t("params.web") }}:</div>
                <div class="value">{{ facility.web | checkParam }}</div>

                <div class="label">{{ $t("params.activities") }}:</div>
                <div class="value" v-if="sports[facility.sport]">
                  {{ $t("campus." + sports[facility.sport].name) | checkParam }}
                </div>
                <div class="value" v-else>-</div>

                <div class="label">{{ $t("params.megafonia") }}:</div>
                <div class="value">{{ facility.megafonia | checkParam }}</div>

                <div class="label">{{ $t("params.parking") }}:</div>
                <div class="value">{{ facility.parking | checkParam }}</div>

                <div class="label">{{ $t("params.grada") }}:</div>
                <div class="value">{{ facility.grada | checkParam }}</div>

                <div class="label">{{ $t("params.illumination") }}:</div>
                <div class="value">
                  {{ facility.illumination | checkParam }}
                </div>

                <div class="label">{{ $t("params.defibrillator") }}:</div>
                <div class="value">
                  {{ facility.defibrillator | checkParam }}
                </div>

                <div class="label">{{ $t("params.warmup_zone") }}:</div>
                <div class="value">{{ facility.warmup_zone | checkParam }}</div>

                <div class="label">{{ $t("params.longitud") }}:</div>
                <div class="value">{{ facility.longitud | checkParam }}</div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.city") }}:</div>
                <div class="value">{{ facility.city | checkParam }}</div>

                <div class="label">{{ $t("params.address") }}:</div>
                <div class="value">{{ facility.address | checkParam }}</div>

                <div class="label">{{ $t("params.country") }}:</div>
                <div class="value">
                  <Country
                    v-if="facility.country_id"
                    :country="country"
                  ></Country>
                  <span v-else>-</span>
                </div>

                <div class="label">
                  <Email :email="$t('params.email') + ':'"></Email>
                </div>
                <div class="value">{{ facility.email | checkParam }}</div>

                <div class="label">{{ $t("params.spectators") }}:</div>
                <div class="value">{{ facility.spectators | checkParam }}</div>

                <div class="label">{{ $t("params.changing_rooms") }}:</div>
                <div class="value">
                  {{ facility.changing_rooms | checkParam }}
                </div>

                <template v-if="facility.sport == '1'">
                  <div class="label">{{ $t("params.grass") }}:</div>
                  <div class="value">
                    {{ grassOptions[facility.ground_type] | checkParam }}
                  </div>
                </template>

                <template v-else>
                  <div class="label">{{ $t("params.pavement") }}:</div>
                  <div class="value">
                    {{ pavementOptions[facility.ground_type] | checkParam }}
                  </div>
                </template>

                <div class="value" v-else>
                  {{ pavementOptions[facility.ground_type] | checkParam }}
                </div>

                <div class="label">{{ $t("params.wifi") }}:</div>
                <div class="value">{{ facility.wifi | checkParam }}</div>

                <div class="label">{{ $t("params.infirmary") }}:</div>
                <div class="value">{{ facility.infirmary | checkParam }}</div>

                <div class="label">{{ $t("params.grada_type") }}:</div>
                <div class="value">
                  {{ grada_typeOptions[facility.grada_type] | checkParam }}
                </div>

                <div class="label">{{ $t("params.bar") }}:</div>
                <div class="value">{{ facility.bar | checkParam }}</div>

                <div class="label">{{ $t("params.closed_perimeter") }}:</div>
                <div class="value">
                  {{ facility.closed_perimeter | checkParam }}
                </div>

                <div class="label">{{ $t("params.latitud") }}:</div>
                <div class="value">{{ facility.latitud | checkParam }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name">{{ $t("params.meteocat") }}</v-flex>
              <v-flex xs12 md12>
                <div
                  v-if="facility.meteocat"
                  class="meteocat"
                  v-html="facility.meteocat"
                ></div>
                <div v-else>{{ $t("undefined") }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <LastUpdate :data="facility.user_modify"></LastUpdate>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="section-container" id="notes">
        <NoteList
          :notes="facility.notes"
          :page="'facility'"
          :id="id"
          @create_note="createNote"
        ></NoteList>
      </v-layout>
    </v-container>
    <!-- <ContactRelationsList :contacts_rel="facility.current_roles" class="contact right"></ContactRelationsList> -->
  </div>
</template>

<script>
import i18n from "@/i18n";
import NoteList from "@/components/ui/NoteList";
import TeamCard from "@/components/ui/cards/mini/Team";
import Topbar from "@/components/ui/Topbar";

import ContactRelationsList from "@/components/ui/ContactRelationsList";

import Phone from "@/components/ui/labels/Phone";
import Email from "@/components/ui/labels/Email";
import Country from "@/components/ui/labels/Country";
import LastUpdate from "@/components/ui/LastUpdate";

export default {
  name: "CardVolunteer",
  components: {
    NoteList,
    TeamCard,
    Topbar,
    Phone,
    Email,
    Country,
    ContactRelationsList,
    LastUpdate
  },
  props: {},
  data() {
    return {
      pavementOptions: {
        linolelum: i18n.t("params.linolelum"),
        terratzo: i18n.t("params.terratzo"),
        portland: i18n.t("params.portland")
      },
      grassOptions: {
        artificial: i18n.t("params.artificial"),
        natural: i18n.t("params.natural")
      },
      grada_typeOptions: {
        covered: i18n.t("params.covered"),
        uncovered: i18n.t("params.uncovered")
      },
      si_no_nsncOptions: {
        "1": i18n.t("si"),
        "2": i18n.t("no"),
        "0": i18n.t("nsnc")
      },
      id: this.$route.params.id,
      current_roles: [],
      meteocat:
        '<iframe src="https://static-m.meteo.cat/ginys/municipal8d?location=170448&language=ca&color=2c3e50&tempFormat=ºC" title="Predicció municipal a 8 dies" frameborder="0" style="border: 0" scrolling="no" width="520" height="218"></iframe>'
    };
  },
  computed: {
    facility() {
      var oFacility = {
        ...this.$store.getters["facilitys/get_by_id"](this.$route.params.id)
      };
      if (!oFacility) oFacility = {};
      oFacility.notes = ObjectToArray(oFacility.notes);
      oFacility.notes.sort(function(n1, n2) {
        if (moment(n1.last_update).valueOf() < moment(n2.last_update).valueOf())
          return 1;
        return -1;
      });

      if (typeof oFacility.current_roles === "undefined")
        oFacility.current_roles = [];
      else {
        oFacility.current_roles.forEach(role => {
          role.visible = true;
        });
      }

      this.current_roles = oFacility.current_roles;
      return oFacility;
    },

    sports() {
      return this.$store.getters.getSports();
    },

    country() {
      if (this.facility.country_id) {
        return {
          ...this.$store.getters.getCountryByID(this.facility.country_id)
        };
      }
      return {};
    }
  },
  created() {
    this.$overlay.loading();

    this.$store.commit("setTopbarActionsVisible", true);
    this.$store.commit("setMenuVisible", true);

    var id = this.$route.params.id;
    var self = this;
    this.$store.dispatch("facilitys/load_by_id", { id: id }).then(function() {
      self.$overlay.hide();
      // var ofacility = {...self.$store.getters[ 'facilitys/get_by_id' ]( self.$route.params.id )};
      // if( !ofacility ) ofacility = {};

      // // var aEvents = [];
      // // if( typeof oClub.teams !== 'undefined' ){
      // //     for( var key in oClub.teams ){
      // //         var team = oClub.teams[ key ];
      // //         if( typeof aEvents[ team.event.id ] === 'undefined' ){
      // //             team.event.name = this.formatEventName( team.event.name, team.event.edition );
      // //             aEvents[ team.event.id ] = team.event;
      // //             aEvents[ team.event.id ].teams = [];
      // //         }
      // //         aEvents[ team.event.id ].teams.push( {
      // //             name: ( team.name == null )? oClub.name : team.name,
      // //             category: team.category,
      // //             status: team.status
      // //         });
      // //     }
      // // }
      // // oClub.events = ObjectToArray( aEvents );

      // ofacility.notes = ObjectToArray( ofacility.notes );

      // if( typeof ofacility.current_roles === 'undefined' ) ofacility.current_roles = []
      // else{
      //     ofacility.current_roles.forEach( role => {
      //         role.visible = true
      //     })
      // }

      // self.facility = ofacility
    });
  },
  methods: {
    createNote() {
      this.$card.note({
        current_page: "facility",
        current_id: this.$route.params.id
      });
    },

    createContactRelationship() {
      this.$card.contactrel({
        current_page: "facility",
        current_id: this.$route.params.id
      });
    },

    getCountry(id) {
      if (id) {
        return { ...this.$store.getters.getCountryByID(id) };
      }
      return false;
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "remove":
          this.fnRemove(emit.params);
          break;
        case "create_note":
          this.createNote(emit.params);
          break;
        case "create_relationship":
          this.createContactRelationship(emit.params);
          break;
        case "rel_facility_event":
          this.fnRelFacilityEvent(emit.params);
          break;
        case "destroy":
          this.fnDestroy(emit.params);
          break;
      }
    },

    fnRemove() {
      var self = this;
      this.$popup.confirm(
        {
          message: i18n.t("facilitys.remove_message"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          self.$store.dispatch("facilitys/remove", self.id).then(function() {
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var page = event ? "event_" : "";
            page = page + "facilitys";

            self.$router.push({
              name: page,
              params: {
                event: event
                  ? self.$root
                      .formatEventUrl(event.name, event.edition)
                      .replace("/event/", "")
                  : null
              }
            });
          });
        }
      );
    },

    getPosition(position) {
      var pos = this.$store.getters["facilitys/getPosition"](position);
      if (pos && typeof pos.name !== "undefined") {
        return pos.name;
      }

      return null;
    },

    editRole(key) {
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event
        ? this.$root
            .formatEventUrl(event.name, event.edition)
            .replace("/event/", "")
        : null;
      var page = event ? "event_" : "";
      page = page + "facilitys_role_edit";
      var role = this.facility.current_roles[key];

      var type = "";
      switch (parseInt(role.contact_type_id)) {
        case 107:
          type = "player";
          break;
        case 5:
        case 108:
        case 6:
          type = "manager";
          break;
        case 1:
        case 2:
          type = "staff";

        case 111:
          type = "team";
          break;
      }

      this.$router.push({
        name: page,
        params: {
          event: event,
          id: this.facility.id,
          role_id: role.id,
          type: type
        }
      });
    },

    fnRelFacilityEvent() {
      if (!this.$store.getters.isEventSelected) {
        var self = this;
        this.$card.relFacilityEvent({
          facility_id: this.$route.params.id,
          event_id: this.$store.getters["events/getCurrentEvent"]().id,
          callBack: function(plug, params, store) {
            self.$store
              .dispatch("facilitys/addRelFacilityEvent", {
                facility_id: plug.params.facility.value,
                event_id: plug.params.event.value
              })
              .then(function() {
                self.$popup.alert({
                  message: i18n.t("facilitys.created_rel_facility_event"),
                  btnSuccess: i18n.t("accept")
                });
                self.$card.close();
              })
              .catch(function(e) {
                self.$popup.alert({
                  message: i18n.t("facilitys." + e),
                  btnSuccess: i18n.t("accept")
                });
              });
          }
        });
      } else {
        this.$popup.alert({
          message: i18n.t("facilitys.exist_rel_facility_event"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    fnDestroy() {
      this.$destroy();
    }
  },
  filters: {
    formatType(value) {
      switch (value) {
        case null:
          return "";
          break;
        case 1:
          return "Administrador Backoffice";
          break;
        case 3:
          return "Administrador MicCamps";
          break;
        case 4:
          return "Usuari MicCamps";
          break;
        case 10:
          return "Administrador club ZonaEquipos";
          break;
        case 11:
          return "Usuari team ZonaEquipos";
          break;
        case 20:
          return "Player Campus";
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#facility {
  width: 100%;
  display: inline-block;

  .container {
    width: calc(100%);
    padding: 0px;
    max-width: 100%;

    &.main {
      overflow-y: auto;
      height: calc(100vh - 110px);
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }
    }
  }

  .contact {
    width: 20%;
    width: 350px;
    padding: 20px;
  }

  .logo {
    width: 150px;
    height: 150px;
    border-radius: 50%;

    img {
      object-fit: contain;
      object-position: center;
      height: 100%;
      width: auto;
      margin: 0 auto;
      display: block;
      margin-top: 50px;
      opacity: 0.5;
    }
  }
  .info {
    .container {
      margin: 0;
      padding: 0 20px;
      padding-left: 40px;
      width: 100%;

      .section {
        margin-bottom: 25px;

        .name {
          font-weight: lighter;
          font-size: 24px;
          @include font-size(14px);
          border-bottom: 1px solid #ddd;
          margin: 10px 0 20px 0;
          color: $main-color;
          text-transform: uppercase;
          margin-bottom: 20px;
          border-bottom: 2px solid $complem-color-dark;
          color: $complem-color-dark;
        }

        .label {
          font-family: $text-light;
          @include font-size(14px);
          width: 40%;
          float: left;
          line-height: 20px;
        }

        .value {
          font-family: $text;
          font-weight: lighter;
          @include font-size(14px);
          width: 60%;
          float: left;
          margin-bottom: 10px;
        }

        .edit {
          background-image: url(/img/edit-b.svg);
          background-size: 15px;
          background-repeat: no-repeat;
          background-position: left center;
          position: absolute;
          right: 0;
          top: -5px;
          padding-left: 20px;
          text-transform: none;
          font-weight: bold;
        }
      }

      .meteocat {
        margin: 0 auto;
        width: fit-content;
      }
    }

    &.role .name {
      position: relative;
      width: fit-content;
      cursor: pointer;

      &::after {
        content: "";
        width: 30px;
        height: 15px;
        background: url(/img/down.svg);
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: center right;
        position: absolute;
      }
    }
  }
}
</style>
